import { render, staticRenderFns } from "./worksheet-layout.vue?vue&type=template&id=884e3550"
import script from "./worksheet-layout.vue?vue&type=script&lang=js"
export * from "./worksheet-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports